<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
    <rect width="30" height="30" :fill="backgroundColor" rx="7.5" />
    <path
      :fill="iconColor"
      fill-rule="evenodd"
      d="M20.527 8.218l.964.964.964-.964c.269-.268.692-.29.984-.062l.07.062c.27.27.29.692.062.985l-.062.07-.963.964.963.964c.291.291.291.763 0 1.055-.29.29-.763.29-1.054 0l-.964-.964-.964.964c-.27.268-.692.29-.985.062l-.07-.062c-.269-.27-.29-.692-.062-.985l.062-.07.964-.964-.964-.964c-.291-.291-.291-.763 0-1.055.291-.29.763-.29 1.055 0z"
      clip-rule="evenodd"
    />
    <path
      :fill="iconColor"
      d="M14.127 8c-1.802 0-3.263 1.46-3.263 3.26 0 1.802 1.461 3.261 3.262 3.261 1.802 0 3.263-1.46 3.263-3.26 0-1.802-1.46-3.261-3.262-3.261zM15.99 16.383h-3.728c-1.801 0-3.262 1.46-3.262 3.262v2.328h10.253v-2.328c0-1.802-1.46-3.262-3.262-3.262z"
    />
  </svg>
</template>
<script>
export default {
  name: 'DeleteAccountIcon',
  props: {
    theme: {
      type: String,
      default: 'light', // light | dark
    },
  },
  data() {
    return {
      darkColor: '#262626',
      lightColor: '#fff',
    };
  },
  computed: {
    backgroundColor() {
      return this.theme === 'light' ? this.darkColor : this.lightColor;
    },
    iconColor() {
      return this.theme === 'light' ? this.lightColor : this.darkColor;
    },
  },
};
</script>
